module.exports = __webpack_public_path__ + "static/img/advantage1.08306668.png";